export default __webpack_public_path__ + "static/media/bjBgPrt.0267e588.webp";